import { z } from 'zod';
import { defaulted, objectIdSchema, translatableString } from '../common.js';
import { blockCommonSchema, listHeaderSchema, listSelectionSchema } from './base.js';
/**
 * Do'kon bloklari.
 *
 * DIQQAT: narx ko'rsatish uchun blok darajasida sozlama YO'Q (ADR-004).
 * Narx `variant.price === null` bo'lsa avtomatik «Narxni so'rang» ga aylanadi.
 */
/** 21 — Mahsulotlar to'plami */
export const productsGridBlock = blockCommonSchema.extend({
    type: z.literal('products-grid'),
    data: listHeaderSchema.extend({
        selection: defaulted(listSelectionSchema),
        columns: z.union([z.literal(2), z.literal(3), z.literal(4)]).default(4),
        /** `auto` rejimida saralash tartibi */
        sort: z.enum(['popular', 'price-asc', 'price-desc', 'newest']).default('popular'),
    }),
});
/** 22 — Mahsulotlar karuseli */
export const productSliderBlock = blockCommonSchema.extend({
    type: z.literal('product-slider'),
    data: listHeaderSchema.extend({
        selection: defaulted(listSelectionSchema),
        autoplay: z.boolean().default(false),
    }),
});
/** 23 — Kategoriyalar */
export const categoriesGridBlock = blockCommonSchema.extend({
    type: z.literal('categories-grid'),
    data: z.object({
        title: translatableString({ max: 200 }),
        categoryIds: z.array(objectIdSchema).max(24).default([]),
        layout: z.enum(['grid', 'tiles']).default('grid'),
        columns: z.union([z.literal(2), z.literal(3), z.literal(4), z.literal(6)]).default(3),
        showProductCount: z.boolean().default(true),
    }),
});
/** 24 — Brendlar chizig'i */
export const brandsStripBlock = blockCommonSchema.extend({
    type: z.literal('brands-strip'),
    data: z.object({
        title: translatableString({ max: 200 }),
        brandIds: z.array(objectIdSchema).max(24).default([]),
        isCarousel: z.boolean().default(true),
        grayscale: z.boolean().default(true),
    }),
});
/** 25 — Mahsulotlarni taqqoslash jadvali */
export const productCompareBlock = blockCommonSchema.extend({
    type: z.literal('product-compare'),
    data: z.object({
        title: translatableString({ max: 200 }),
        /**
         * Bo'sh bo'lishi mumkin: admin blokni avval qo'shadi, keyin mahsulot tanlaydi.
         * Saytda 2 tadan kam mahsulot bo'lsa blok umuman render qilinmaydi —
         * bu Service/komponent qatlamining ishi, sxemaning emas.
         */
        productIds: z.array(objectIdSchema).max(4).default([]),
        /** Qaysi xarakteristika qatorlari taqqoslanadi (spec `key` bo'yicha) */
        specKeys: z.array(z.string().trim().max(120)).max(30).default([]),
    }),
});
//# sourceMappingURL=shop.js.map